export default "/images/93f84ae2435ed5a7d7c2da78d3f4c0a6.avif";